export const showLoading = () => ({ type: 'ux.SHOW_LOADING' });
export const hideLoading = () => ({ type: 'ux.HIDE_LOADING' });
export const showConfirm = (title, body, onConfirm) => ({
  type: 'ux.SHOW_CONFIRM',
  payload: { title, body, onConfirm }
});
export const hideConfirm = () => ({ type: 'ux.HIDE_CONFIRM' });
export const showAsyncLoading = () => ({ type: 'ux.SHOW_ASYNC_LOADING' });
export const hideAsyncLoading = () => ({ type: 'ux.HIDE_ASYNC_LOADING' });
